import { notify } from '@billy/design-system'
import { useTranslation } from 'react-i18next'
import { useMutation } from 'react-query'

import { UpdateAccountResponse } from '@features/accounts/query-api'

import { NotificationKeys } from '../../../../../enums/notificationKeys'
import { APIError } from '../../../../../utils'
import { createAccountFromTemplate } from '../query-api'

interface UseCreateAccountFromTemplateProps {
  onError?: (error: APIError) => void
  onSuccess?: (data: UpdateAccountResponse) => void
}

export const useCreateAccountFromTemplate = ({ onError, onSuccess }: UseCreateAccountFromTemplateProps) => {
  const { t } = useTranslation()
  const { mutate: createAccount, isLoading: isProcessing } = useMutation(createAccountFromTemplate, {
    onError,
    onSuccess: async (data) => {
      await onSuccess?.(data)
      notify({
        id: NotificationKeys.AccountFromTemplateCreate,
        message: t('coa.account_from_base_form.success_message'),
        variant: 'success',
      })
    },
  })

  return { createAccount, isProcessing }
}
